import type { OwnerPayload, WorldItemStatus, WorldSettings, WorldShell } from '../../shared/coloring/world/types';

import type { Tree3dWorkKind } from './kinds';

export type Tree3dWork = {
  id: string;
  kind: Tree3dWorkKind;
  source: 'upload' | 'preset';
  variant?: number;
  hasName: boolean;
  imageUrl: string;
  createdAt: string;
  status: WorldItemStatus;
};
export type Tree3dWorld = WorldShell<WorldSettings> & { works: Tree3dWork[] };
export type Tree3dOwnerPayload = OwnerPayload<Tree3dWorld>;

const seg = encodeURIComponent;
/** Адреса страниц «Новогодней ёлки 3D»; демо (`demo`) работает без сервера. */
export const tree3dPaths = {
  manage: '/new-year-tree-3d/manage',
  demo: '/new-year-tree-3d/demo',
  display: (code: string) => `/new-year-tree-3d/display/${seg(code)}`,
  add: (code: string) => `/new-year-tree-3d/add/${seg(code)}`,
  draw: (code: string) => `/new-year-tree-3d/draw/${seg(code)}`,
  capture: (code: string) => `/new-year-tree-3d/capture/${seg(code)}`,
  print: (code: string) => `/new-year-tree-3d/print/${seg(code)}`,
  moderate: (code: string) => `/new-year-tree-3d/moderate/${seg(code)}`,
  /** Ссылка по секрету модератора: нужна только старым ссылкам, новые ведут на `moderate`. */
  moderator: (secret: string) => `/new-year-tree-3d/moderator/${seg(secret)}`,
};
